import { PlaybackProvider } from '@app/core/playback/context/PlaybackProvider';
import { isStationTranscriptionEnabled } from '@app/modules/fragments/screens/view/components/transcription/lib/is-transcription-enabled';
import { Box, Grid, Stack, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useFragment } from '../../hooks/useFragment';
import { TranscriptionPanel } from '../transcription/panel/TranscriptionPanel';
import { AudioFragmentMedia } from './audio/AudioFragmentMedia';
import { AudioSkeleton } from './audio/AudioSkeleton';
import { FragmentMetadata } from './FragmentMetadata';
import { VideoFragmentMedia } from './video/VideoFragmentMedia';
import { VideoSkeleton } from './video/VideoSkeleton';

/**
 * Fragment view:
 * - md and below: media, transcription, metadata (stacked full width).
 * - lg and above: media/metadata in the left column and transcription in the right column.
 */
export function FragmentMediaDetail() {
  const { fragment, station } = useFragment();
  const theme = useTheme();
  const isMdOrLower = useMediaQuery(theme.breakpoints.down('lg'));
  const isVideo = fragment.mediaType === 'VIDEO';
  const hasTranscription = isStationTranscriptionEnabled(station);

  const media = !fragment.mediaCompletedAt ? (
    isVideo ? (
      <VideoSkeleton />
    ) : (
      <AudioSkeleton />
    )
  ) : isVideo ? (
    <VideoFragmentMedia />
  ) : (
    <AudioFragmentMedia />
  );

  return (
    <PlaybackProvider>
      {isMdOrLower ? (
        <Stack spacing={2}>
          <Box sx={{ width: '100%' }}>{media}</Box>
          {hasTranscription && <TranscriptionPanel />}
          <FragmentMetadata />
        </Stack>
      ) : (
        <Grid container spacing={3}>
          <Grid item xs={12} lg={8}>
            <Stack spacing={2}>
              <Box sx={{ width: '100%' }}>{media}</Box>
              <FragmentMetadata />
            </Stack>
          </Grid>
          <Grid item xs={12} lg={4}>
            {hasTranscription && <TranscriptionPanel />}
          </Grid>
        </Grid>
      )}
    </PlaybackProvider>
  );
}
